import VueRouter, { Route } from "vue-router"

const routerHistories: Route[] = []
let examResultPreviusNameMap: string[] = []

export function setupExamRouterHistories(
  item: VueRouter, 
  examPreviusNameMap: string[]
){
  examResultPreviusNameMap = [...examResultPreviusNameMap, ...examPreviusNameMap]
  item.afterEach((_, from)=>{
    routerHistories.push(from)
  })
}

export function getLastExamRoute(){
  if (examResultPreviusNameMap.length == 0) {
    throw new Error("setupRouterHistories not setup")
  }
  const found = routerHistories.reverse().find(item => examResultPreviusNameMap.includes(item.name))
  return found
}
